module.exports = __webpack_public_path__ + "static/img/b2g.57753a81.webp";